<template>
  <div>
    <div class="group">
      <div class="random-con" v-for="(item, index) in randomArr" :key="index">
        <!-- <p class="line"></p> -->
        <div
          class="random-word"
          :style="{
            top: `${Math.random() * 160}px`,
          }"
          :class="{
            'is-right': item.status == 'right',
            'is-normal': item.status == 'normal',
            'is-active-wrong': item.status == 'wrong',
          }"
        >
          {{ item.word }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dialog from "../views/mixins/dialog";
export default {
  name: "RandomStyle",
  props: {
    randomWordData: {
      type: String,
      default: "Javscript",
    },
  },
  mixins: [dialog],
  mounted() {
    this.randomData();
    console.log(this.randomArr, "randomArr");
  },
  data() {
    return {
      offsetTop: 0,
      randomArr: [],
    };
  },
  methods: {
    randomData() {
      // this.randomArr = this.randomWordData.split("")
      let originArr = Array.from(new Set(this.randomWordData));
      originArr.forEach((ele, index) => {
        // this.randomWordData.split("").forEach((ele, index) => {
        let obj = {
          word: ele,
          status: index === 0 ? "active" : "normal",
        };
        this.randomArr.push(obj);
      });
      var len = this.randomWordData.length;
      for (var i = 0; i < len - 1; i++) {
        var index = parseInt(Math.random() * (len - i));
        var temp = this.randomArr[index];
        this.randomArr[index] = this.randomArr[len - i - 1];
        this.randomArr[len - i - 1] = temp;
      }
    },
    handlerWord(key) {
      for (let index = 0; index < this.randomArr.length; index++) {
        const element = this.randomArr[index];
        if (key === element.word) {
          element.status = "right";
        }
      }
    },
    updateWrongNum() {
      this.wrongNum = 0;
      this.sentenceDataArr.forEach((item) => {
        item.forEach((obj) => {
          if (obj.status === "wrong") {
            this.wrongNum++;
          }
        });
      });
    },
    nextWord() {
      let originArr = Array.from(new Set(this.randomWordData));
      return originArr;
    },
  },
};
</script>

<style scoped lang="less">
.group {
  margin: 0 auto;
  height: 240px;
  width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  .random-con {
    height: 100%;
    overflow: hidden;
    position: relative;
    width: 37px;
    .random-word {
      width: 35px;
      position: absolute;
      height: 35px;
      line-height: 35px;
      text-align: center;
      font-size: 24px;
      border: 1px solid #3295db;
      &:before {
        position: absolute;
        bottom: 35px;
        left: 50%;
        transform: translateX(-50%);
        display: table;
        content: "";
        width: 2px;
        height: 200px;
        background-color: #3295db;
      }
    }
    .is-right {
      background: #95c590;
      color: #edf7e7;
    }
    .is-active-wrong {
      background: red;
      color: #edf7e7;
    }
  }
}
@keyframes swing {
  0% {
    border-color: #3295db;
  }
  50% {
    border-color: transparent;
  }
  100% {
    border-color: #3295db;
  }
}
</style>
